// TOPページヘッダー変化用
document.addEventListener('DOMContentLoaded', function () {
  const ifTransparent = document.getElementById('transparent');

  function handleScroll() {
    let scrollPosition = window.scrollY;
    if (scrollPosition > 100) {
      ifTransparent.classList.remove('transparent');
    } else {
      ifTransparent.classList.add('transparent');
    }
  }

  window.addEventListener('load', handleScroll);
  window.addEventListener('scroll', handleScroll);
});

